import { render, staticRenderFns } from "./step-sync.vue?vue&type=template&id=635376f0&scoped=true&"
import script from "./step-sync.vue?vue&type=script&lang=js&"
export * from "./step-sync.vue?vue&type=script&lang=js&"
import style0 from "./step-sync.vue?vue&type=style&index=0&id=635376f0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635376f0",
  null
  
)

export default component.exports